// frontend/src/components/ProfileBlockDisplays/BarsBlockDisplay.js
import React from 'react';

const BarsBlockDisplay = ({ content }) => {
    if (!content || !content.items || content.items.length === 0) return null;

    return (
        <div className="p-6 md:p-8 rounded-xl border border-outlineVariant bg-surface text-surface-on">
            {content.title && (
                <h3 className="text-headline-small font-bold mb-6 text-surface-on">
                    {content.title}
                </h3>
            )}
            <div className="flex flex-col gap-6">
                {content.items.map((item, index) => (
                    <div key={index}>
                        <div className="flex justify-between items-center mb-2">
                            <span className="text-body-large font-bold text-surface-on">
                                {item.label}
                            </span>
                            <span className="text-body-medium font-bold text-surface-onVariant">
                                {item.value}%
                            </span>
                        </div>
                        <div className="w-full h-3 bg-surface-containerHighest rounded-full overflow-hidden">
                            <div
                                className="h-full bg-primary transition-all duration-1000 ease-out rounded-full"
                                style={{ width: `${item.value}%` }}
                            ></div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BarsBlockDisplay;
